import React, { Component } from "react";
import { Div, Text, Image } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import MarketingScheduleDemo from "./MarketingScheduleDemo";
import BrandImages from "../common/BrandImages";

import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <Text textSize={{ xs: "subheader5", md: "subheader5" }} m="1rem 0">
          {children}
        </Text>
      );
    },
    [BLOCKS.HEADING_1]: (node, children) => (
      <Text
        tag="h1"
        m={{ t: "1rem", b: "3rem" }}
        textSize={{ xs: "subheader3", md: "display3" }}
        textWeight="700"
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_2]: (node, children) => (
      <Text
        textSize={{ xs: "heading", md: "display5" }}
        textWeight="700"
        m={{ t: "1rem", b: "2rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <Text
        textSize={{ xs: "subheader2", md: "title3" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <Text
        textSize={{ xs: "subheader1", md: "paragraph3" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <Text
        textSize={{ xs: "subheader1", md: "paragraph3" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
      >
        {children}
      </Text>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <Div
        textSize={{ xs: "subheader1", md: "subheader2" }}
        textWeight="700"
        m={{ t: "1rem", b: "1rem" }}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    ),
    [BLOCKS.OL_LIST]: (node, children) => (
      <ol>
        {node.content.map(item => {
          return documentToReactComponents(item, options);
        })}
      </ol>
    ),
    [BLOCKS.UL_LIST]: (node, children) => (
      <ul>
        {node.content.map(item => {
          return documentToReactComponents(item, options);
        })}
      </ul>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => <Text tag="li">{children}</Text>,
    [BLOCKS.HR]: (node, children) => (
      <Div h="1px" bg="border">
        {children}
      </Div>
    ),
    [BLOCKS.QUOTE]: (node, children) => (
      <Text
        textSize={{ xs: "subheader1", md: "subheader3" }}
        m="1rem 0"
        textAlign="center"
        textWeight="700"
      >
        {children}
      </Text>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
      if ("embed" in node.data.target.fields) {
        return (
          <Div
            dangerouslySetInnerHTML={{
              __html: node.data.target.fields.embed["en-US"],
            }}
          ></Div>
        );
      }

      return <Text>{children}</Text>;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, children) => {
      const type = node.data.target.fields.file["en-US"].contentType;

      switch (type) {
        case "image/gif":
        case "image/png":
        case "image/jpg":
        case "image/jpeg":
          return (
            <Image
              alt={
                node.data.target.fields.description &&
                node.data.target.fields.description["en-US"]
              }
              src={node.data.target.fields.file["en-US"].url}
            />
          );
      }
      return false;
    },
  },
};

export default class MarketingHero extends Component {
  render() {
    const { title, content, brands, form, formTitle } = this.props;

    return (
      <WebsiteContainer>
        <CustomContainer p={{ x: { xs: "0", md: "2.5rem" } }}>
          <Div m={{ t: "3.375rem" }} className="marketing">
            <Div d="flex" flexDir={{ xs: "column", md: "row" }}>
              <Div flexGrow="1 1 50%" p={{ x: { xs: "1.5rem", md: "0" } }}>
                <Text
                  textSize={{ xs: "caption4", md: "display2" }}
                  className="hero-heading"
                  textWeight="bold"
                >
                  {title}
                </Text>

                {documentToReactComponents(content, options)}
              </Div>

              <Div
                d={{ xs: "block", md: "none" }}
                m={{ t: "4.25rem", b: "2.5rem" }}
              >
                <BrandImages
                  content={{
                    brandImages: brands.map(brand => ({
                      img: brand.file.url,
                      imgLink: brand.description,
                    })),
                  }}
                />
              </Div>

              <Div
                flexGrow="1 1 50%"
                p={{ l: { xs: "0", md: "3rem", lg: "5.625rem" } }}
              >
                <MarketingScheduleDemo form={form} title={formTitle} />
              </Div>
            </Div>

            <Div d={{ xs: "none", md: "block" }} m={{ t: "5.375rem" }}>
              <BrandImages
                content={{
                  brandImages: brands.map(brand => ({
                    img: brand.file.url,
                    imgLink: brand.description,
                  })),
                }}
              />
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
